/**
 * Schema version of the persisted domain model.
 *
 * Bumped whenever the shape of stored data changes. Backup files carry this
 * value (T-502) so that import can migrate older data forward and refuse
 * anything written by a newer version rather than guessing at it.
 */
export const SCHEMA_VERSION = 1

/**
 * Human-readable version of the domain layer, surfaced in exports and the
 * report footer so a generated document can be traced to what produced it.
 */
export const CORE_VERSION = '0.0.0'
